// Utils
import { getCookie } from "./cookies";
import fetch from "./fetch";
import { getStoredUser } from "./currentUser";
import errorReporter from "./errorReporter";

export const updateUserPreferences = () => {
  const preferencesCookie = getCookie("tracking-preferences");
  const currentUser = getStoredUser();

  if (currentUser && currentUser.id) {
    fetch(`users/${currentUser.id}/tracking_preferences`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ segment_integrations: preferencesCookie }),
    }).catch((e) =>
      errorReporter.error(e, "Failed to send tracking preferences"),
    );
  }
};
